import { Locale } from 'modules/i18n';

export const noDataPlaceholderTranslation = {
  [Locale.en]: {
    text: 'No requests recorded for the selected period',
  },
};
